module.exports = __webpack_public_path__ + "media/images/default_avatar-5e0529a3e4974b365e1699cbea1afc7c.png";